import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";
import { cn } from "@util/helpers";

type HomepageLifestyleStoriesProps = {
  /** The props needed for the card. */
  cardProps: ComponentProps<typeof Card>;
};

/**
 * Renders an individual lifestyle story card for the homepage lifestyle section.
 */
const HomepageLifestyleStories = ({
  cardProps,
}: HomepageLifestyleStoriesProps): React.ReactElement => {
  const variant: CardVariations = {
    image: {
      position: "left",
      width: "!w-120px lg:!w-1/3",
      aspectRatio: "aspect-3x2",
      imageClassName: "object-cover",
      orientation: "landscape",
      filters: {
        w: ImagePresets.MICRO,
        dpr: 1,
        f: "webp",
      },
    },
    content: {
      width: "w-full-120px lg:w-2/3",
      extraClass: "pl-4 text-white",
      updatedTimeColor: "!text-white",
    },
    title: {
      color: "text-white",
      size: "text-base",
      extraClass: "font-lct font-bold",
    },
    kicker: {
      color: "text-gray-515",
      extraClass: "break-words font-poppins text-4xs font-light leading-4",
    },
    section: { extraClass: cn("[&>a:hover>span]:underline") },
  };

  return (
    <div
      className="story py-3"
      data-testid="homepage-lifestyle-stories-individual-component"
    >
      <Card {...cardProps} variations={variant} />
    </div>
  );
};

export default HomepageLifestyleStories;
